module.exports = require('./helpers/bundle-url').getBundleURL('8peBl') + "logo-dark.eefe0b7f.svg";